/*eslint-disable */
import React, { Component } from "react";
import * as yup from "yup";
import {
  Button,
  Table,
  Segment,
  Input,
  Dropdown,
  Checkbox,
  Form as FormUi
} from "semantic-ui-react";
import { Formik, Form, Field, getIn, FieldArray, ErrorMessage } from "formik";
import { MyInput } from "../../dynamicComponent/myInputs";
import CreateAxios from "../../axiosComponent/create";
import ReadAxios from "../../axiosComponent/read";
import * as Yup from 'yup';
import SearchDropdownVehicle from "../../createShipmentComponent/searchDropdownVehicle";
import SearchDropdownD from "../../createShipmentComponent/searchDropdownD";
import cogoToast from 'cogo-toast';
import { translate } from "react-i18next";
import { AllRegex } from "../../../utils/validation";
import { DateData } from '../../formikInput/date'
import { DATA_LOGGER_NO_MANDATORY, DRIVER_NAME_REQUIRED, DRIVER_NUMBER_REQUIRED, INVALID_LICENCE_NO, INVALID_MOBILE_NO, INVALID_VEHICLE_NO, NETWORK_PROVIDER_REQUIRED, OWNERSHIP_TYPE_REQUIRED, TRACKING_TYPE_REQUIRED, VEHICLE_NO_REQUIRED, VEHICLE_TYPE_REQUIRED , PROMPTS} from "../../../utils/validationConstant";
import {FEATURES, LOCAL_STORAGE, DATE_FORMATS, disableTrackingType} from '../../../utils/constant'
import moment from 'moment';

class FormikAllotedVehicles extends Component {

  state = {
    rowitems: [],
    vendorItems: [],
    trackingItems: [],
    Network: [],
    Ownership: [],
    vendor_value: LOCAL_STORAGE.vendor_Id,
    disabled: this.props.deliveries ? (this.props.deliveries.consignor ? false : true) : true,
    warnings: {PUC : false, insurance:false, permit:false, road_tax:false, fitness:false},
    serviceTypeId: this.props.order.service_type_id
  }

  format_params = (data) => {
    if (data) {
      return data.map((d, i) => {
        return {
          vendor: d.vendor,
          vehicle_number: d.vehicle_number,
          vehicle_seal_no: d.vehicle_seal_no,
          vehicle_type: d.vehicle_type,
          driver_id: d.driver_id,
          driver_name: d.driver_name,
          driver_number: d.driver_number,
          driver_lic_no: d.driver_lic_no,
          driver_lic_expiry_date: d.driver_lic_expiry_date,
          vendor_id: d.vendor_id,
          network_provider: d.network_provider,
          tracking_type: d.tracking_type,
          reefer_type_and_model: d.reefer_type_and_model,
          ownership_type: d.ownership_type,
          number_of_drivers: d.number_of_drivers,
          truck_type: d.truck_type,
          data_logger_available: d.data_logger_available,
          data_logger_no: d.data_logger_no,
          red_line_inside_container: d.red_line_inside_container,
          gps_available: d.gps_available,
          vehicle_registration_date: d.vehicle_registration_date,
          PUC_expiry_date: d.PUC_expiry_date,
          insurance_expiry_date: d.insurance_expiry_date,
          permit_expiry_date: d.permit_expiry_date,
          road_tax_expiry_date: d.road_tax_expiry_date,
          fitness_expiry_date: d.fitness_expiry_date,
          ewaybill_part_b : d.ewaybill_part_b,
        }
      })
    }
  }

  getData = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/DriverMaster`
    }).then((res) => {
      if (res.status === 200) {

        let rows = res.data.resultSet.map((item, index) => {
          return {
            key: index + 1,
            text: item.driverName,
            value: item.driverMasterId,
            raw: { ...item },
          };
        })
        this.setState({
          rowItems: rows
        })
      }
    })

    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`
    }).then((res) => {
      if (res.status === 200) {

        let vendors = res.data.resultSet.map((item, index) => {
          return {
            key: index + 1,
            text: item.transporterName,
            value: item.transporterMasterId,
            raw: { ...item },
          };
        })
        this.setState({
          vendorItems: vendors
        })
      }
    })

    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleTypeMaster`
    }).then((res) => {
      if (res.status === 200) {
        let vehicles = res.data.resultSet.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType + " " + "(" + item.vehicleTypeTonnage + ")",
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
        this.setState({
          vehicleItems: vehicles
        })
      }
    })

    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/trackingTypeMaster`
    }).then((res) => {
      if (res.status === 200) {
        let result = res.data.resultSet.length > 0 ? (
          this.props.order.service_type_id=== 2 ? res.data.resultSet : 
          res.data.resultSet.filter((trackingType)=>trackingType.trackingTypeId !== 5) //excluding PTL Tracking for FTL order
        )
        : []

        let track = []
        if (FEATURES.trackingTypeFilter) {
          let trackFilter = result.filter((item, index) => {
            let compare = item.trackingType.toLowerCase()
            if (compare.includes("simcard")) {
              return item;
            }
          })

          track = trackFilter.map((item, index) => {
            return {
              key: index + 1,
              text: item.trackingType,
              value: item.trackingTypeId,
              raw: { ...item },
            };
          })
          this.setState({
            trackingItems: track
          })
        } else {
          track = result.map((item, index) => {
            return {
              key: index + 1,
              text: item.trackingType,
              value: item.trackingTypeId,
              raw: { ...item },
            };
          })
          this.setState({
            trackingItems: track
          })
        }
      }
      else {
        cogoToast.error(res.status)
      }
    }).catch((err) => {
      let error_msg = err.response ? err.response.data.message : err.message
      cogoToast.error(error_msg)
    });

    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/networkProviderMaster`
    }).then((res) => {
      if (res.status === 200) {
        let network = res.data.resultSet.map((item, index) => {
          return {
            key: index + 1,
            text: item.networkProviderName,
            value: item.networkProviderMasterId,
            raw: { ...item },
          };
        })
        this.setState({
          Network: network
        })
      }
      else {
        cogoToast.error(res.status)
      }
    }).catch((err) => {
      let error_msg = err.response ? err.response.data.message : err.message
      cogoToast.error(error_msg)
    });


    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`
    }).then((res) => {
      if (res.status === 200) {
        let ownership = res.data.resultSet.map((item, index) => {
          return {
            key: index + 1,
            value: item.vehicleOwnershipTypeId,
            text: item.vehicleOwnershipTypeName,
            raw: { ...item },
          };
        })
        this.setState({
          Ownership: ownership
        })
      }
      else {
        cogoToast.error(res.status)
      }
    }).catch((err) => {
      let error_msg = err.response ? err.response.data.message : err.message
      cogoToast.error(error_msg)
    });



  }

  handleWarnings = (warningName, value) => {
    let budgeted_time_string = this.props.order?.route_details?.budgetedTime.split(" ")
    let budgeted_time = Number(budgeted_time_string[0])
    let currentTime = new Date().getTime();
    let updatedDate
    if(budgeted_time){
      updatedDate = new Date(currentTime + budgeted_time * 60 * 60 * 1000);
    }
    if(updatedDate){
      let warningObj = this.state.warnings
      value ? (new Date(value) <= updatedDate ?  warningObj[warningName]=true : warningObj[warningName]=false ) : warningObj[warningName]=false
      this.setState({warnings:warningObj})
    }
  }


  componentDidMount() {
    this.getData()
  }

  render() {
    const { t, acceptance } = this.props;
    const disabled_status = acceptance[0]
    let customerNo = LOCAL_STORAGE.customerNo
    let regex = AllRegex.VehicleNumber
    let driverNumberRegex = FEATURES.elevenNumberValidation ? AllRegex.BrazilMobileNumber : AllRegex.MobileNumber
    let driverLicenseRegex = FEATURES.brazilVehiclelicenseValidation ? AllRegex.BrazilLicenseNo : AllRegex.LicenseNumber


    const ValidationSchema = Yup.object().shape({
      data: Yup.array()
        .of(
          Yup.object().shape({
            vehicle_seal_no: yup.mixed().optional(),
            vehicle_number: Yup.string()
              .matches(regex, INVALID_VEHICLE_NO)
              .when(['ownership_type'], {
                is: (ownership_type) => {
                  return ownership_type
                },
                then: yup.string().required(VEHICLE_NO_REQUIRED),
                otherwise: yup.string().optional()
              }),
            data_logger_available: yup.mixed().optional(),
            data_logger_no: yup.mixed().when('data_logger_available', {
              is: (data_logger_available) => {
                return data_logger_available && data_logger_available == 1 ? true : false
              },
              then: yup.mixed().required(DATA_LOGGER_NO_MANDATORY),
              otherwise: yup.string().nullable().optional()
            }),
            vehicle_type: Yup.string()
              .when(['vehicle_number', 'ownership_type'], {
                is: (vehicle_number, ownership_type) => {
                  return vehicle_number || ownership_type
                },
                then: yup.string().required(VEHICLE_TYPE_REQUIRED),
                otherwise: yup.string().optional()
              }),
            ownership_type: FEATURES.vehicleOwnerShipOptional ?
              Yup.string().optional()
              :
              Yup.string().when(['vehicle_number'], {
                is: (vehicle_number) => {
                  return vehicle_number
                },
                then: yup.string().required(OWNERSHIP_TYPE_REQUIRED),
                otherwise: yup.string().optional()
              }),

            driver_name: Yup.string().when('tracking_type', {
              is: (tracking_type) => {
                return tracking_type /* && tracking_type == 2 */ ? true : false
              },
              then: this.props.order.service_type_id=== 2? yup.string().optional() : yup.string().required(DRIVER_NAME_REQUIRED),
              otherwise: yup.string().optional()
            }),
            driver_number: Yup.string()
              .matches(driverNumberRegex, INVALID_MOBILE_NO)
              .when('tracking_type', {
                is: (tracking_type) => {
                  return tracking_type/*  && tracking_type == 2  */ ? true : false
                },
                then: this.props.order.service_type_id=== 2? yup.string().optional() : yup.string().required(DRIVER_NUMBER_REQUIRED),
                otherwise: yup.string().optional()
              }),
            driver_lic_no: yup
              .string()
              .nullable().optional()
              .matches(driverLicenseRegex, INVALID_LICENCE_NO),
            network_provider: Yup.string().when('tracking_type', {
              is: (tracking_type) => {
                return tracking_type && tracking_type == 2 ? true : false
              },
              then: yup.string().nullable().required(NETWORK_PROVIDER_REQUIRED),
              otherwise: yup.string().nullable().optional()
            }),
            tracking_type: Yup.mixed().when(['ownership_type', 'vehicle_number'], {
              is: (ownership_type, vehicle_number) => {
                return (ownership_type || vehicle_number) && customerNo != 1122
              },
              then: yup.mixed().required(TRACKING_TYPE_REQUIRED),
              otherwise: yup.mixed().optional()
            }),
          }, [
            //['vehicle_number', 'vehicle_type'], // <--- adding your fields which need validation
            ['vehicle_number', 'ownership_type'],
            //['vehicle_type', 'ownership_type'],
            //['vehicle_type', 'ownership_type', 'vehicle_number']
            ['ownership_type', 'vehicle_number']
          ]))
    });
    return (
      <div>
        <Formik
          initialValues={{
            data: [{
              vehicle_number: '',
              driver_name: "",
              driver_id: "",
              driver_number: "",
              vehicle_seal_no: "",
              driver_lic_no: '',
              driver_lic_expiry_date: '',
              vendor_id: this.state.vendor_value,
              vendor_lr_number: this.props.order.deliveries[0].lr_no || "",
              vendor_lr_date: this.props.order.deliveries[0].lr_date || "",
              tracking_type: this.props?.order?.tracking_type ? this.props.order.tracking_type : (this.props.order.service_type_id=== 2 ? 5 : (FEATURES.simcardTrackingTypeCust ? 2 : "")),
              truck_type: this.props.order.truck_type || "",
              vehicle_type: this.props.order.proposed_vehicle_type || "",
              vehicle_type_name: this.props.order.vehicle_type || "",
              network_provider: '',
              reefer_type_and_model: "",
              number_of_drivers: this.props.order.number_of_drivers || 1,
              ownership_type: '',
              data_logger_available: 0,
              data_logger_no: '',
              red_line_inside_container: 0,
              gps_available: 0,
              vehicle_registration_date: "",
              PUC_expiry_date: "",
              insurance_expiry_date: "",
              permit_expiry_date: "",
              road_tax_expiry_date: "",
              fitness_expiry_date: "",
              ewaybill_part_b : true,
            }]
          }}
          validationSchema={ValidationSchema}
          onSubmit={(values, { setSubmitting, props }) => {

            // return
            let Id = window.location.search.split("=")[1];
            // let vendor_value = localStorage.getItem("vendorId")
            let vendor_ID = parseInt(this.state.vendor_value)
            // console.log(vendor_ID,vendor_value)

            let params = this.format_params(values.data)

            if (this.props.order_status == 'ACK' && (this.props.orderTruckLoadType == 1 || this.props.orderTruckLoadType == 2)) {
              if (params[0]["vehicle_number"] != "" || (this.props.order.service_type_id !== 2 && params[0]["tracking_type"] != "") || this.props.orderTruckLoadType == 2) {
                setSubmitting(true)
                CreateAxios({
                  completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${Id}/allocate/vehicle`,
                  payload: {
                    vendor_id: vendor_ID,
                    vehicle_number: params[0]["vehicle_number"] ? params[0]["vehicle_number"] : null,
                    vehicle_seal_no: params[0]["vehicle_seal_no"] ? params[0]["vehicle_seal_no"] : null,
                    driver_name: params[0]["driver_name"] ? params[0]["driver_name"] : null,
                    driver_id: params[0]["driver_id"] ? params[0]["driver_id"] : null,
                    driver_number: params[0]["driver_number"] ? params[0]["driver_number"] : null,
                    driver_lic: params[0]["driver_lic_no"] ? params[0]["driver_lic_no"] : null,
                    driver_lic_expiry_date: params[0]["driver_lic_expiry_date"] ? params[0]["driver_lic_expiry_date"] : null,
                    vendor_lr_number: params[0]["vendor_lr_number"] ? params[0]["vendor_lr_number"] : null,
                    vendor_lr_date: params[0]["vendor_lr_date"] ? params[0]["vendor_lr_date"] : null,
                    vehicle_number: params[0]["vehicle_number"] ? params[0]["vehicle_number"] : null,
                    vehicle_registration_date: params[0]["vehicle_registration_date"] && params[0]["vehicle_registration_date"] instanceof Date && !isNaN(params[0]["vehicle_registration_date"]) ? moment(params[0]["vehicle_registration_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    PUC_expiry_date: params[0]["PUC_expiry_date"] && params[0]["PUC_expiry_date"] instanceof Date && !isNaN(params[0]["PUC_expiry_date"]) ? moment(params[0]["PUC_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    insurance_expiry_date: params[0]["insurance_expiry_date"] && params[0]["insurance_expiry_date"] instanceof Date && !isNaN(params[0]["insurance_expiry_date"]) ? moment(params[0]["insurance_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    permit_expiry_date: params[0]["permit_expiry_date"] && params[0]["permit_expiry_date"] instanceof Date && !isNaN(params[0]["permit_expiry_date"]) ? moment(params[0]["permit_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    road_tax_expiry_date: params[0]["road_tax_expiry_date"] && params[0]["road_tax_expiry_date"] instanceof Date && !isNaN(params[0]["road_tax_expiry_date"]) ? moment(params[0]["road_tax_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    fitness_expiry_date: params[0]["fitness_expiry_date"] && params[0]["fitness_expiry_date"] instanceof Date && !isNaN(params[0]["fitness_expiry_date"]) ? moment(params[0]["fitness_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    data_logger_available: params[0]["data_logger_available"] ? params[0]["data_logger_available"] : null,
                    data_logger_no: params[0]["data_logger_no"] ? params[0]["data_logger_no"] : null,
                    tracking_type: params[0]["tracking_type"] ? params[0]["tracking_type"] : null,
                    ownership_type_id: params[0]["ownership_type"] ? params[0]["ownership_type"] : null,
                    vehicle_type: params[0]["vehicle_type"] ? params[0]["vehicle_type"] : null,
                    reefer_type_and_model: params[0]["reefer_type_and_model"] ? params[0]["reefer_type_and_model"] : null,
                    network_provider: params[0]["network_provider"] ? params[0]["network_provider"] : null,
                    number_of_drivers: params[0]["number_of_drivers"] ? params[0]["number_of_drivers"] : null,
                    truck_type: params[0]["truck_type"] ? params[0]["truck_type"] : null,
                    red_line_inside_container: params[0]["red_line_inside_container"],
                    gps_available: params[0]["gps_available"],
                    ewaybill_part_b : params[0]["ewaybill_part_b"],
                  }
                }).then((response) => {
                  cogoToast.success("Successfully accepted with vehicle details")
                  setTimeout(() => { window.location.reload(); }, 1000)
                })
                  .catch((err) => {
                    cogoToast.error(err?.response?.data?.message)
                    // setTimeout(() => {  window.location.reload(); }, 1000)
                  });
              }
              else {
                cogoToast.warn("Please provide vehicle details.")
              }
            } else {
              if (params[0]["vehicle_number"] != "" || (this.props.order.service_type_id !== 2 && params[0]["tracking_type"] != "")) {
                setSubmitting(true)
                CreateAxios({
                  completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${Id}/allocate/vehicle`,
                  payload: {
                    vendor_id: vendor_ID,
                    vehicle_number: params[0]["vehicle_number"] ? params[0]["vehicle_number"] : null,
                    vehicle_seal_no: params[0]["vehicle_seal_no"] ? params[0]["vehicle_seal_no"] : null,
                    driver_name: params[0]["driver_name"] ? params[0]["driver_name"] : null,
                    driver_id: params[0]["driver_id"] ? params[0]["driver_id"] : null,
                    driver_number: params[0]["driver_number"] ? params[0]["driver_number"] : null,
                    driver_lic: params[0]["driver_lic_no"] ? params[0]["driver_lic_no"] : null,
                    driver_lic_expiry_date: params[0]["driver_lic_expiry_date"] ? params[0]["driver_lic_expiry_date"] : null,
                    vendor_lr_number: params[0]["vendor_lr_number"] ? params[0]["vendor_lr_number"] : null,
                    vendor_lr_date: params[0]["vendor_lr_date"] ? params[0]["vendor_lr_date"] : null,
                    vehicle_number: params[0]["vehicle_number"] ? params[0]["vehicle_number"] : null,
                    vehicle_registration_date: params[0]["vehicle_registration_date"] && params[0]["vehicle_registration_date"] instanceof Date && !isNaN(params[0]["vehicle_registration_date"]) ? moment(params[0]["vehicle_registration_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    PUC_expiry_date: params[0]["PUC_expiry_date"] && params[0]["PUC_expiry_date"] instanceof Date && !isNaN(params[0]["PUC_expiry_date"]) ? moment(params[0]["PUC_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    insurance_expiry_date: params[0]["insurance_expiry_date"] && params[0]["insurance_expiry_date"] instanceof Date && !isNaN(params[0]["insurance_expiry_date"]) ? moment(params[0]["insurance_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    permit_expiry_date: params[0]["permit_expiry_date"] && params[0]["permit_expiry_date"] instanceof Date && !isNaN(params[0]["permit_expiry_date"]) ? moment(params[0]["permit_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    road_tax_expiry_date: params[0]["road_tax_expiry_date"] && params[0]["road_tax_expiry_date"] instanceof Date && !isNaN(params[0]["road_tax_expiry_date"]) ? moment(params[0]["road_tax_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    fitness_expiry_date: params[0]["fitness_expiry_date"] && params[0]["fitness_expiry_date"] instanceof Date && !isNaN(params[0]["fitness_expiry_date"]) ? moment(params[0]["fitness_expiry_date"]).format(DATE_FORMATS.DATE_YYYYMMDD) : null,
                    data_logger_available: params[0]["data_logger_available"] ? params[0]["data_logger_available"] : null,
                    data_logger_no: params[0]["data_logger_no"] ? params[0]["data_logger_no"] : null,
                    tracking_type: params[0]["tracking_type"] ? params[0]["tracking_type"] : null,
                    ownership_type_id: params[0]["ownership_type"] ? params[0]["ownership_type"] : null,
                    vehicle_type: params[0]["vehicle_type"] ? params[0]["vehicle_type"] : null,
                    reefer_type_and_model: params[0]["reefer_type_and_model"] ? params[0]["reefer_type_and_model"] : null,
                    network_provider: params[0]["network_provider"] ? params[0]["network_provider"] : null,
                    number_of_drivers: params[0]["number_of_drivers"] ? params[0]["number_of_drivers"] : null,
                    truck_type: params[0]["truck_type"] ? params[0]["truck_type"] : null,
                    red_line_inside_container: params[0]["red_line_inside_container"],
                    gps_available: params[0]["gps_available"],
                    ewaybill_part_b : params[0]["ewaybill_part_b"],
                  }
                }).then((response) => {
                  cogoToast.success("Successfully accepted with vehicle details")
                  setTimeout(() => { window.location.reload(); }, 1000)
                })
                  .catch((err) => {
                    cogoToast.error(err?.response?.data?.message)
                    // setTimeout(() => {  window.location.reload(); }, 1000)
                  });
              }
              else {
                setSubmitting(true)
                let vendorId = LOCAL_STORAGE.vendor_Id
                CreateAxios({
                  completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${Id}/accept/vendor/${vendorId}`,
                }).then((response) => {
                  cogoToast.success("Successfully accepted")
                  setTimeout(() => { window.location.reload(); }, 1000)
                })
                  .catch((err) => {
                    cogoToast.error(err.response.data.message)
                  });
              }
            }
          }}
        >
          {({ values, errors, initialValues, isSubmitting, touched, setFieldValue }) => {
            const setVehicleNumber = (name, value) => {

              setFieldValue(
                "data[0].vehicle_number",
                value.raw ? value.raw.vehicleNumber : value
              );
              FEATURES.enable_vehicle_type_while_allocation && setFieldValue("data[0].vehicle_type", value.raw ? value.raw.vehicleTypeMasterId : "");
              setFieldValue(
                "data[0].ownership_type",
                value.raw ? (value.raw.vehicleOwner == "Market" ? 2 : 1) : ""
              );
              if(value.raw){
               setVehicleDocumentDates(value.raw)
              }else{
                if(value && AllRegex.VehicleNumber.test(value)){
                  setVehicleDocumentDates({})
                }
              }
            };

            const setVehicleDocumentDates = (result)=>{
              let budgeted_time_string = this.props.order?.route_details?.budgetedTime.split(" ")
              let budgeted_time = Number(budgeted_time_string[0])
              let currentTime = new Date().getTime();
              let updatedDate
              if(budgeted_time){
                updatedDate = new Date(currentTime + budgeted_time * 60 * 60 * 1000);
              }
              let values = {reg:null, PUC : null, insurance : null,road_tax : null, permit:null, fitness:null, foodPermit:null, distributionPermit:null, securityClearancePermit:null }
              values.reg = result?.regDate && moment(result.regDate, DATE_FORMATS.DATE_DDMMYYYY,true).isValid() ? new Date(moment(result.regDate, DATE_FORMATS.DATE_DDMMYYYY)) : updatedDate
              values.PUC = result?.vehiclePUCExpiryDate && moment(result.vehiclePUCExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehiclePUCExpiryDate) : updatedDate
              values.road_tax = result?.vehicleRoadTaxValidityDate && moment(result.vehicleRoadTaxValidityDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleRoadTaxValidityDate) : updatedDate
              values.permit = result?.vehiclePermitExpiryDate && moment(result.vehiclePermitExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehiclePermitExpiryDate) : updatedDate
              values.insurance = result?.vehicleInsuranceExpiryDate && moment(result.vehicleInsuranceExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleInsuranceExpiryDate) : updatedDate
              values.fitness = result?.vehicleFitnessCertExpiryDate && moment(result.vehicleFitnessCertExpiryDate, DATE_FORMATS.YYYYMMDDHHmmss,true).isValid() ? new Date(result.vehicleFitnessCertExpiryDate) : updatedDate
              
              
              setFieldValue("data[0].vehicle_registration_date", values.reg )

              setFieldValue("data[0].PUC_expiry_date", values.PUC )
              this.handleWarnings("PUC",values.PUC )

              setFieldValue("data[0].road_tax_expiry_date", values.road_tax )
              this.handleWarnings("road_tax",values.road_tax)

              setFieldValue("data[0].permit_expiry_date", values.permit )
              this.handleWarnings("permit",values.permit)

              setFieldValue("data[0].insurance_expiry_date", values.insurance )
              this.handleWarnings("insurance",values.insurance)

              setFieldValue("data[0].fitness_expiry_date", values.fitness )
              this.handleWarnings("fitness",values.fitness)
            }

            const setDriverName = (name, value) => {
              setFieldValue(
                "data[0].driver_id",
                value.raw ? value.raw.driverMasterId : undefined
              );
              setFieldValue("data[0].driver_name", value.raw ? value.raw.driverName : value);
              setFieldValue("data[0].driver_number", value.raw ? value.raw.driverContact : "");
              setFieldValue("data[0].driver_lic_no", value.raw ? value.raw.driverLicense : "");
              setFieldValue("data[0].driver_lic_expiry_date", value.raw && value?.raw?.driverLicenceExpiryDate && (Date.parse(value.raw.driverLicenceExpiryDate)) ? new Date(value.raw.driverLicenceExpiryDate) : "");
              setFieldValue(
                "data[0].network_provider",
                value.raw ? value.raw.serviceProviderId : ""
              );
            };


            return (
              <Form className="form ui m-3">
                <Table size="small" color="blue">


                  <Table.Body className="p-1">
                    <FieldArray
                      name="data"
                      render={arrayHelpers => (
                        <>
                          {values.data.map((object, index) => {
                            return (
                              <>
                                <Segment className="padding-0-imp">
                                  <div className="ui form tiny p-bold-600">


                                    <FormUi.Group
                                      inline
                                      className="vehicle-detail-heading-wrapper padding-15px_lr"
                                    >
                                      <FormUi.Field>
                                        <h3 className="vehicle-detail-heading padding-left-0">
                                          {t("vehicle_details") || "Vehicle Details"}
                                        </h3>
                                      </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group className="padding-15px_lr">
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.vehicle_number") ||
                                            "Vehicle Number"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <SearchDropdownVehicle
                                          setField={setVehicleNumber}
                                          masterRoute={
                                            "vehicleMaster"
                                          }
                                          masterRouteKey="vehicleId"
                                          masterRouteName="vehicleNumber"
                                          fieldName="data[0].vehicle_number"
                                          className="ui input icon"
                                          value={values.data[0].vehicle_number ? values.data[0].vehicle_number : ""}
                                          searchWithVehicleType={values.data[0].vehicle_type_name}
                                          searchWithVehicleTypePresent={FEATURES.enable_vehicle_type_while_allocation? false : true}
                                        />

                                        <ErrorMessage name="data[0].vehicle_number">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>

                                      </FormUi.Field>

                                      <FormUi.Field width={1} />
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.vehicle_type") || "Vehicle Type"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          name="data[0].vehicle_type"
                                          disabled={FEATURES.enable_vehicle_type_while_allocation ? false : true}
                                          //readOnly={localStorage.getItem('customerNumber') == 1122 ? true : false}
                                          clearable
                                          search
                                          style={{ width: "100%" }}
                                          selection
                                          placeholder={"Select Vehicle"}
                                          onChange={(name, data) => {
                                            setFieldValue("data[0].vehicle_type", data.value);
                                          }}
                                          options={this.state.vehicleItems}
                                          // disabled={!isEditing ? true : false}
                                          error={
                                            touched.vehicle_type && errors.vehicle_type
                                              ? true
                                              : false
                                          }
                                          value={values.data[0].vehicle_type}
                                        />

                                        <ErrorMessage name="data[0].vehicle_type">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>
                                      </FormUi.Field>
                                    </FormUi.Group>


                                    <FormUi.Group className="padding-15px_lr">
                                      { !FEATURES.vehicleOwnerShipOptional ?
                                        (<>
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.ownership_type") ||
                                                "Ownership Type"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Dropdown
                                              name="data[0].ownership_type"
                                              clearable
                                              search
                                              style={{ width: "100%" }}
                                              selection
                                              placeholder={"Ownership Type"}
                                              onChange={(name, data) => {
                                                if (data.value) {
                                                  setFieldValue("data[0].ownership_type", +data.value)
                                                } else {
                                                  setFieldValue("data[0].ownership_type", "")
                                                }
                                                ;
                                              }}
                                              options={this.state.Ownership}
                                              // disabled={
                                              // values.data[0].ownership_type
                                              //     ? true
                                              //     : false
                                              // }
                                              error={
                                                touched.vehicle_type && errors.vehicle_type
                                                  ? true
                                                  : false
                                              }
                                              value={values.data[0].ownership_type}
                                            />
                                            <ErrorMessage name="data[0].ownership_type">
                                              {(msg) => {
                                                return (
                                                  <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                                )
                                              }}
                                            </ErrorMessage>
                                          </FormUi.Field>
                                        </>)
                                        :
                                        <FormUi.Field width={6} />}
                                      <FormUi.Field width={1} />
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.truck_type") || "Truck Type"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          name="data[0].truck_type"
                                          clearable
                                          search
                                          style={{ width: "100%" }}
                                          selection
                                          placeholder={
                                            t("reefer_type_and_model.placeholder") ||
                                            "Network Provider"
                                          }
                                          onChange={(name, data) => {
                                            setFieldValue("data[0].truck_type", data.value);
                                          }}
                                          options={[
                                            { key: "1", text: "Dry Container", value: 1 },
                                            {
                                              key: "2",
                                              text: "Reefer Container",
                                              value: 2,
                                            },
                                            { key: "3", text: "Open Body", value: 3 },
                                          ]}
                                          value={values.data[0].truck_type}
                                        />

                                      </FormUi.Field>
                                    </FormUi.Group>

                                    {!FEATURES.hideGPSAvailableField ?
                                      (
                                        <FormUi.Group className="padding-15px_lr" >

                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.gps_available") || "GPS Available"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Checkbox
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "data[0].gps_available",
                                                  e.target.checked ? 1 : 0
                                                )
                                              }
                                              id="ga"
                                              type="checkbox"
                                              className="form-check-input large ml-3"
                                            />
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.tracking_type") || "Tracking Type"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Dropdown
                                              //disabled={+localStorage.getItem('customerNumber') == 1166 ? true : false}
                                              name="tracking_type"
                                              clearable
                                              search
                                              style={{ width: "100%" }}
                                              selection
                                              disabled={this.state.serviceTypeId == 2}
                                              placeholder={
                                                t("tracking_type.placeholder") ||
                                                "Select Tracking Type"
                                              }
                                              onChange={(name, data) => {
                                                setFieldValue("data[0].tracking_type", data.value);
                                              }}
                                              options={this.state.trackingItems}
                                              error={
                                                touched.tracking_type && errors.tracking_type
                                                  ? true
                                                  : false
                                              }
                                              defaultValue={values.data[0].tracking_type}
                                            />

                                            <ErrorMessage name="data[0].tracking_type">
                                              {(msg) => {
                                                return (
                                                  <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                                )
                                              }}
                                            </ErrorMessage>

                                          </FormUi.Field>



                                        </FormUi.Group>
                                      )
                                      :
                                      ""}

                                    {/* {values.data[0].vehicle_seal_no != null ?
                                      ( */}
                                    <FormUi.Group className="padding-15px_lr" >
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("vehicle_seal_number.title") || "Vehicle Seal No"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Field
                                          name="data[0].vehicle_seal_no"
                                          component={MyInput}
                                          maxLength={15}
                                          type="text"
                                          placeholder={values.data[0].vehicle_seal_no}
                                          onChange={(name, data) => {
                                            setFieldValue("data[0].vehicle_seal_no", data.value);
                                          }}
                                          error={
                                            touched.vehicle_seal_no && errors.vehicle_seal_no
                                              ? true
                                              : false
                                          }
                                        />

                                        <ErrorMessage name="data[0].vehicle_seal_no">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>

                                      </FormUi.Field>
                                      <FormUi.Field width={1} />
                                     {FEATURES.showUpdateEwayBill_VehicleAllocation &&
                                     <>
                                      <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.update_ewaybill") || "Update Eway-bill"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Checkbox
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "data[0].ewaybill_part_b",
                                                  e.target.checked ? true : false
                                                )
                                              }
                                              checked={values.data[0].ewaybill_part_b}
                                              id="ew"
                                              type="checkbox"
                                              className="form-check-input large ml-3"
                                            />
                                          </FormUi.Field>
                                          </> }

                                    </FormUi.Group>

                                    {/*============>Vehicle Document Section<===========*/}

                                    { !FEATURES.hideVehicleDocumentsSection ?
                                      (<>
                                        <FormUi.Group
                                          inline
                                          className="vehicle-detail-heading-wrapper padding-15px_lr"
                                        >
                                          <FormUi.Field>
                                            <h3 className="vehicle-detail-heading padding-left-0">
                                              {t("vehicle_documents") || "Vehicle Documents"}
                                            </h3>
                                          </FormUi.Field>
                                        </FormUi.Group>

                                        <FormUi.Group className="padding-15px_lr">
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.vehicle_registration_date") ||
                                                "Vehicle Registration Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].vehicle_registration_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              value={values.data[0].vehicle_registration_date}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />

                                          { FEATURES.uaeVehicleCustomer ? 
                                          <>
                                          
                                          </>
                                          :<>
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.PUC_expiry_date") ||
                                                "PUC Expiry Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].PUC_expiry_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              value={values.data[0].PUC_expiry_date}
                                              onChangeExtra={(val)=>this.handleWarnings("PUC",val)}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                            {this.state.warnings.PUC &&
                                            <div className="mt-1 mb-1">
                                            <small class="alert-warning pt-2 pb-2 w3-tiny">
                                            {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                                            </small>
                                            </div>}
                                          </FormUi.Field>
                                          </>}
                                        </FormUi.Group>

                                        {FEATURES.uaeVehicleCustomer ? 
                                        <>
                                        
                                        </>
                                        :<>
                                        <FormUi.Group className="padding-15px_lr">
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.insurance_expiry_date") ||
                                                "Insurance Expiry Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].insurance_expiry_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              onChangeExtra={(val)=>this.handleWarnings("insurance",val)}
                                              value={values.data[0].insurance_expiry_date}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                            {this.state.warnings.insurance &&
                                            <div className="mt-1 mb-1">
                                            <small class="alert-warning pt-2 pb-2 w3-tiny">
                                            {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                                            </small>
                                            </div>}
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.permit_expiry_date") ||
                                                "Permit Expiry Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].permit_expiry_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              onChangeExtra={(val)=>this.handleWarnings("permit",val)}
                                              value={values.data[0].permit_expiry_date}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                            {this.state.warnings.permit &&
                                            <div className="mt-1 mb-1">
                                            <small class="alert-warning pt-2 pb-2 w3-tiny">
                                            {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                                            </small>
                                            </div>}
                                          </FormUi.Field>
                                        </FormUi.Group>

                                        <FormUi.Group className="padding-15px_lr">
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.road_tax_expiry_date") ||
                                                "Road Tax Expiry Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].road_tax_expiry_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              onChangeExtra={(val)=>this.handleWarnings("road_tax",val)}
                                              value={values.data[0].road_tax_expiry_date}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                            {this.state.warnings.road_tax &&
                                            <div className="mt-1 mb-1">
                                            <small class="alert-warning pt-2 pb-2 w3-tiny">
                                            {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                                            </small>
                                            </div>}
                                          </FormUi.Field>
                                          <FormUi.Field width={1} />
                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.fitness_expiry_date") ||
                                                "Fitness Expiry Date"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <DateData
                                              name="data[0].fitness_expiry_date"
                                              autoComplete="off"
                                              popperClassName="dateTime"
                                              dateFormat={DATE_FORMATS?.ddMMyyyy}
                                              onChangeExtra={(val)=>this.handleWarnings("fitness",val)}
                                              value={values.data[0].fitness_expiry_date}
                                              customInput={
                                                <Input
                                                  icon="time"
                                                  className="poupDate"
                                                  iconPosition="left"
                                                />
                                              }
                                            />
                                            {this.state.warnings.fitness &&
                                            <div className="mt-1 mb-1">
                                            <small class="alert-warning pt-2 pb-2 w3-tiny">
                                            {PROMPTS.DOCUMENTS_ABOUT_TO_EXPIRE}
                                            </small>
                                            </div>}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                        </>}
                                      </>)

                                      :

                                      ""

                                    }

                                    {/*============>Driver Section<===========*/}

                                    <FormUi.Group
                                      inline
                                      className="vehicle-detail-heading-wrapper padding-15px_lr"
                                    >
                                      <FormUi.Field>
                                        <h3 className="vehicle-detail-heading padding-left-0">
                                          {t("driver_details") || "Driver Details"}
                                        </h3>
                                      </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group className="padding-15px_lr">
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.number_of_driver") ||
                                            "No Of Drivers"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <Dropdown
                                          name="data[0].number_of_drivers"
                                          clearable
                                          search
                                          // style={{ width: "30%" }}
                                          selection
                                          onChange={(name, data) => {
                                            setFieldValue("data[0].number_of_drivers", data.value);
                                          }}
                                          options={[
                                            { key: "2", text: "1", value: 1 },
                                            { key: "3", text: "2", value: 2 },
                                            { key: "4", text: "3", value: 3 },
                                          ]}

                                          value={values.data[0].number_of_drivers}

                                        // error={
                                        //   touched.network_provider && errors.network_provider
                                        //     ? true
                                        //     : false
                                        // }
                                        />
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.driver_name") || "Driver Name"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field width={3}>
                                        <SearchDropdownD
                                          setField={setDriverName}
                                          masterRoute={`driverMaster`}
                                          className="input ui"
                                          masterRouteKey="driverMasterId"
                                          masterRouteName="driverNameContactNo"
                                          fieldName="data[0].driver_name"
                                          vendorid={this.state.vendor_value}
                                        // value={values.data[0].driver_id}
                                        />
                                        <ErrorMessage name="data[0].driver_name">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>
                                      </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group className="padding-15px_lr">
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.driver_number") || "Driver Number"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}
                                        className="vehicle-detail-wrapper"
                                      >
                                        <Field
                                          name="data[0].driver_number"
                                          component={MyInput}
                                          value={values.data[0].driver_number}
                                          error={
                                            touched.driver_number && errors.driver_number
                                              ? true
                                              : false
                                          }

                                        />
                                        <ErrorMessage name="data[0].driver_number">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>
                                      </FormUi.Field>
                                      <FormUi.Field width={1} />
                                      <FormUi.Field width={3}>
                                        <label>
                                          {t("table_header.licence_number") ||
                                            "Driver Licence Number"}
                                        </label>
                                      </FormUi.Field>
                                      <FormUi.Field
                                        width={3}
                                        className="vehicle-detail-wrapper"
                                      >
                                        <Field
                                          name="data[0].driver_lic_no"
                                          component={MyInput}
                                          placeholder={"Driver Licence Number"}
                                          value={values.data[0].driver_lic_no}
                                        />
                                        <ErrorMessage name="data[0].driver_lic_no">
                                          {(msg) => {
                                            return (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                            )
                                          }}
                                        </ErrorMessage>

                                      </FormUi.Field>
                                    </FormUi.Group>

                                    {!FEATURES.hideNetworkProviderAndLicExpiryFields ?
                                      (<FormUi.Group className="padding-15px_lr">
                                        <FormUi.Field width={3}>
                                          <label>
                                            {t("table_header.network_provider") ||
                                              "Network Provider"}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field width={4}>
                                          <Dropdown
                                            name="data[0].network_provider"
                                            clearable
                                            search
                                            style={{ width: "50%" }}
                                            selection
                                            placeholder={"Network Provider"}
                                            onChange={(name, data) => {
                                              setFieldValue("data[0].network_provider", data.value);
                                            }}
                                            options={this.state.Network}
                                            value={values.data[0].network_provider}
                                            error={
                                              touched.network_provider &&
                                                errors.network_provider
                                                ? true
                                                : false
                                            }
                                          />
                                          <br></br>
                                          <ErrorMessage name="data[0].network_provider">
                                            {(msg) => {
                                              return (
                                                <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                              )
                                            }}
                                          </ErrorMessage>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                          <label>
                                            {t("table_header.license_expiry_date") ||
                                              "Driver Licence Expiry Date"}
                                          </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                          width={3}
                                          className="vehicle-detail-wrapper"
                                        >
                                          <DateData
                                            name="data[0].driver_lic_expiry_date"
                                            autoComplete="off"
                                            popperClassName="dateTime"
                                            dateFormat={DATE_FORMATS?.ddMMyyyy}
                                            value={values.data[0].driver_lic_expiry_date}
                                            customInput={
                                              <Input
                                                icon="time"
                                                className="poupDate"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                          <ErrorMessage name="data[0].driver_lic_expiry_date">
                                            {(msg) => {
                                              return (
                                                <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                              )
                                            }}
                                          </ErrorMessage>

                                        </FormUi.Field>
                                        {/* <FormUi.Field width={1} />
                                                                        <FormUi.Field width={3} />
                                                                        <FormUi.Field width={3} /> */}
                                      </FormUi.Group>)
                                      : ""
                                    }




                                    {this.props.order.load_type_id != 4 ? (
                                      <>
                                        <FormUi.Group
                                          inline
                                          className="vehicle-detail-heading-wrapper padding-15px_lr"
                                        >
                                          <FormUi.Field>
                                            <h3 className="vehicle-detail-heading padding-left-0 ">
                                              Cold Chain Details
                                            </h3>
                                          </FormUi.Field>
                                        </FormUi.Group>

                                        <FormUi.Group className="padding-15px_lr" inline>
                                          {!FEATURES.hideDataLoggerField ?
                                            <>
                                              <FormUi.Field width={3}>
                                                <label>
                                                  {t("table_header.data_logger_available") ||
                                                    "Data Logger Available"}
                                                </label>
                                              </FormUi.Field>
                                              <FormUi.Field width={3}>
                                                <Checkbox
                                                  onChange={(e) =>
                                                    setFieldValue(
                                                      "data[0].data_logger_available",
                                                      e.target.checked ? 1 : 0
                                                    )
                                                  }
                                                  id="dla"
                                                  type="checkbox"
                                                  className="form-check-input large ml-3"
                                                />
                                              </FormUi.Field>
                                              {values.data[0].data_logger_available == 1 && <>
                                                <FormUi.Field width={3}>
                                                  <label>
                                                    {"Data Logger Number"}
                                                  </label>
                                                </FormUi.Field>
                                                <FormUi.Field width={3} className="vehicle-detail-wrapper padding-0-imp-child display-grid-center-imp">
                                                  <Field
                                                    name="data[0].data_logger_no"
                                                    component={MyInput}
                                                    type="text"
                                                    // readOnly={!isEditing ? true : false}
                                                    // value={data[0].data_logger_no}
                                                    error={
                                                      touched.data_logger_no && errors.data_logger_no
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                </FormUi.Field>
                                                <ErrorMessage name="data[0].data_logger_no">
                                                  {(msg) => {
                                                    return (
                                                      <strong className="w3-text-red w3-tiny font-weight-bold">{msg}</strong>
                                                    )
                                                  }}
                                                </ErrorMessage>
                                              </>}

                                            </> : ""}

                                          <FormUi.Field width={3}>
                                            <label>
                                              {t("table_header.red_line_inside_container") ||
                                                "Red-Line inside Container"}
                                            </label>
                                          </FormUi.Field>
                                          <FormUi.Field width={3}>
                                            <Checkbox
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "data[0].red_line_inside_container",
                                                  e.target.checked ? 1 : 0
                                                )
                                              }
                                              id="rlic"
                                              type="checkbox"
                                              className="form-check-input large ml-3"
                                            />
                                          </FormUi.Field>

                                        </FormUi.Group>

                                        {/* <FormUi.Group className="padding-15px_lr" inline>
                                                                        <FormUi.Field width={3}>
                                                                        <label>
                                                                            {t(
                                                                            "table_header.data_logger_recalibration_date"
                                                                            ) || "Data Logger Recalibration Date"}
                                                                        </label>
                                                                        </FormUi.Field>
                                                                        <FormUi.Field width={3}></FormUi.Field>
                                                                        <FormUi.Field width={1} />
                                                                        <FormUi.Field width={3}>
                                                                        <label>
                                                                            {t("table_header.data_logger_number") ||
                                                                            "Data Logger No."}
                                                                        </label>
                                                                        </FormUi.Field>
                                                                        <FormUi.Field width={3}></FormUi.Field>
                                                                        
                                                                    </FormUi.Group> */}
                                      </>
                                    ) : null}
                                  </div>


                                  <center>
                                    <Button
                                      className="m-4"
                                      type="submit"
                                      size="mini"
                                      // disabled={disabled_status}
                                      primary>
                                      {this.props.order_status == "WAITINGVEH" ? t("action_button.accept") || "Accept" : t("action_button.submit") || "Submit"}
                                    </Button>
                                  </center>


                                </Segment>
                                {/*-------> LR Details <------- */}

                                {/* <Table.Row ><Table.Cell className="labelName medium  p-bold-600">{t("LR Details") || "LR Details"}</Table.Cell></Table.Row>

                                                                <Table.Row className="no-border">
                                                    
                                                                    <Table.Cell  className="labelName small  p-bold-600">{t("LR No.") || "LR No."}</Table.Cell>
                                                                    <Table.Cell className="labelName small  p-bold-600">{t("LR Date") || "LR Date"}</Table.Cell>
                                                    
                                                                </Table.Row>

                                                                <Table.Row className="no-border">
                                                    
                                                                    <Table.Cell  className="labelName small  p-bold-600">{t("LR No.") || "LR No."}</Table.Cell>
                                                                    <Table.Cell className="labelName small  p-bold-600">{t("LR Date") || "LR Date"}</Table.Cell>
                                                    
                                                                </Table.Row> */}

                                {/*-------> Vehicle Details <------- */}


                              </>

                            )
                          })}
                        </>
                      )}

                    />
                  </Table.Body>

                </Table>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }
}

export default (translate("alloted_vehicle_details")(FormikAllotedVehicles));